module.exports = __webpack_public_path__ + "static/img/_DSC2330-Edit.a16df9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_DSC2330-Edit.jpg
// module id = 50dX
// module chunks = 0